export type ToolId = "ctcae" | "fieldguide" | "platinuminterval" | "scanplan" | "weightdelta";

export interface ToolDefinition {
  id: ToolId;
  name: string;
  description: string;
  url: string;
}

export const suite = {
  name: "Per Protocol",
  compactName: "PerProtocol",
  domain: "perprotocol.org",
  url: "https://perprotocol.org",
  familyLabel: "Clinical research utilities",
} as const;

export const tools = {
  ctcae: {
    id: "ctcae",
    name: "CTCAEase",
    description: "Find and verify CTCAE grading criteria.",
    url: "https://ctcae.perprotocol.org",
  },
  fieldguide: {
    id: "fieldguide",
    name: "Field Guide",
    description: "Find recruiting clinical trials at the hospitals you choose.",
    url: "https://fieldguide.perprotocol.org",
  },
  platinuminterval: {
    id: "platinuminterval",
    name: "Platinum Interval",
    description: "Calculate ovarian cancer platinum response intervals.",
    url: "https://platinuminterval.perprotocol.org",
  },
  scanplan: {
    id: "scanplan",
    name: "Scan Plan",
    description: "Turn protocol imaging requirements into patient-specific scan dates.",
    url: "https://scanplan.perprotocol.org",
  },
  weightdelta: {
    id: "weightdelta",
    name: "Weight Delta",
    description: "Track weight change from baseline with source-linked CTCAE criteria.",
    url: "https://weightdelta.perprotocol.org",
  },
} as const satisfies Record<ToolId, ToolDefinition>;

export const toolList = [tools.ctcae, tools.fieldguide, tools.platinuminterval, tools.scanplan, tools.weightdelta] as const;
